import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;

export const InputsContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.l}rem;
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
`;

export const AddMachineryButton = styled.button`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  min-height: 4rem;
  min-width: 4rem;
  width: 4rem;
  border: none;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.garnet};
`;
